import React, {useCallback, useContext} from "react";
import {WizardFormInput} from "../wizardFormType/WizardFormInput";
import {WizardFormSelect} from "../wizardFormType/WizardFormSelect";
import {WizardFormDate} from "../wizardFormType/WizardFormDate";
import {WizardFormOption} from "../wizardFormType/WizardFormOption";
import {
    wizardFormType,
    wizardFormTypeDate,
    wizardFormTypeOption,
    wizardFormTypeRadio,
    wizardFormTypeSelect
} from "../../../../../util/Constants";
import {WizardContext} from "../Wizard";
import "react-bootstrap/cjs/divWithClassName";
import {WizardFormListGroup} from "../wizardFormType/WizardFormListGroup";

export function WizardForm() {
    const { wizardForm, step } = useContext(WizardContext);
    const wizardStep = useCallback(
        (idx) => {
            if(step) return step === idx
            else return idx === 1
        },
        [step],
    );

    return (
        wizardForm ?
        wizardForm.map((item, i) =>
            <div data-wizard-type="step-content" data-wizard-state={wizardStep(i+1) ? "current" : "pending"}
                 key={"wizardFormType-" + i}>
                {/*{console.log(item)}*/}
                {/*<h3 className="mb-10 font-weight-bold text-dark">{data.name}</h3>*/}
                {
                    item.map((wizardFormItemData, i) => {
                        switch (wizardFormItemData[wizardFormType]) {
                            case wizardFormTypeSelect :
                                return (
                                    <WizardFormSelect data={wizardFormItemData} key={"wizardFormItem-" + i}/>
                                )
                            case wizardFormTypeRadio :
                                return (
                                    <WizardFormListGroup data={wizardFormItemData} key={"wizardFormItem-" + i}/>
                                )
                            case wizardFormTypeDate :
                                return (
                                    <WizardFormDate data={wizardFormItemData} key={"wizardFormItem-" + i}/>
                                )
                            case wizardFormTypeOption :
                                return (
                                    <WizardFormOption data={wizardFormItemData} key={"wizardFormItem-" + i}/>
                                )
                            default :
                                return (
                                    <WizardFormInput data={wizardFormItemData} key={"wizardFormItem-" + i}/>
                                )

                        }
                    })
                }
            </div>
        )
        :
        <div></div>

    )
}